/**
 * City domain helpers
 */

export function createCityId(name, state) {
  return `${name.replace(/[ -]/g, '_').replace(/'/g, '')}_${state}`.toLowerCase();
}

/** Returns one trimmed reply-to address, or null when blank or invalid. */
export function normalizeStaffReplyToEmail(value) {
  if (typeof value !== 'string' || /[\u0000-\u001f\u007f]/.test(value)) {
    return null;
  }

  const email = value.trim();
  const singleEmail = /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/i;

  return email.length <= 254 && singleEmail.test(email) ? email : null;
}
